import AllVouchers from "../../components/Vouchers/AllVouchers";
import ApprovedVouchers from "../../components/Vouchers/ApprovedVouchers";
import DownloadVoucher from "../../components/Vouchers/DownloadVoucher";
import PendingApproval from "../../components/Vouchers/PendingApproval";
import RejectedVouchers from "../../components/Vouchers/RejectedVouchers";
import SavedVouchers from "../../components/Vouchers/SavedVouchers";
import ReworkHistory from "../../components/Vouchers/ReworkHistory";

export const tabBarOptions = [
  {
    id: 1,
    title: "View All Vouchers",
    // Component: AllVouchers,
    Component: AllVouchers,
    isVoucher: true,
    showTo: ["Store", "L1", "L2", "L3", "Finance"],
  },
  {
    id: 2,
    title: "Vouchers Approved",
    Component: ApprovedVouchers,
    isVoucher: true,
    showTo: ["Store", "L1", "L2", "L3", "Finance"],
  },
  {
    id: 3,
    title: "Vouchers Pending Approval",
    Component: PendingApproval,
    isVoucher: true,
    showTo: ["Store", "L1", "L2", "L3", "Finance"],
  },
  {
    id: 4,
    title: "Vouchers Rejected",
    Component: RejectedVouchers,
    isVoucher: true,
    showTo: ["Store", "L1", "L2", "L3", "Finance"],
  },
  {
    id: 5,
    title: "Saved Vouchers",
    Component: SavedVouchers,
    isVoucher: true,
    showTo: ["Store"],
  },
  {
    id: 6,
    title: "Upload Reports",
    Component: DownloadVoucher,
    isVoucher: true,
    showTo: ["L3", "Finance"],
  },
  {
    id: 7,
    title: "Rework History",
    Component: ReworkHistory,
    isVoucher: true,
    showTo: ["Store", "L1", "L2", "L3", "Finance"],
  },
];
